import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const dateFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
const shortFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
const timeFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

// Plain YYYY-MM-DD dates (no time zone shift).
export function fmtDate(d: string | null | undefined, short = false): string {
  if (!d) return '—';
  return (short ? shortFmt : dateFmt).format(new Date(`${d.slice(0, 10)}T00:00:00Z`));
}

export function fmtDateTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  return timeFmt.format(new Date(d));
}

export function todayLocal(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function scoreTone(score: number | null | undefined, passing = 85, warning = 70): 'pass' | 'warn' | 'fail' | 'none' {
  if (score === null || score === undefined) return 'none';
  if (score >= passing) return 'pass';
  if (score >= warning) return 'warn';
  return 'fail';
}

export function plural(n: number, word: string, pluralWord = `${word}s`) {
  return `${n} ${n === 1 ? word : pluralWord}`;
}
